<template>
    <header>
        <div class="select-box" :class="{active: currentComponent === '1'}" data-id="1" @click="changeNl">0-3岁</div>
        <div class="select-box" :class="{active: currentComponent === '2'}" data-id="2" @click="changeNl">4-9岁</div>
        <div class="select-box" :class="{active: currentComponent === '3'}" data-id="3" @click="changeNl">10-13岁</div>
    </header>
</template>

<script>
    export default {
        name: "Header",
        props:['currentComponent'],
        methods: {
            changeNl: function (e) {
                let id = e.currentTarget.dataset.id
                this.$emit('changeComponent', id)
            }
        }
    }
</script>

<style scoped lang="stylus">
header
    background url("../images/header.png") no-repeat center/cover
    width 100%
    height 132.4vw
    display flex
    justify-content center
    .select-box
        margin-top 122.6vw
        background transparent
        width 26.67vw
        height 7.333vw
        color #fff
        font-size 4vw
        font-weight 600
        display flex
        align-items center
        justify-content center
        &.active
            color #950808
            background #FFFFFF
</style>